import React from 'react';
import type { CatalogValidationIssue } from '../types';

interface ValidationIssuesModalProps {
  issues: CatalogValidationIssue[];
  isOpen: boolean;
  onClose: () => void;
}

export const ValidationIssuesModal: React.FC<ValidationIssuesModalProps> = ({
  issues,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  const errors = issues.filter((i) => i.severity === 'ERROR');
  const warnings = issues.filter((i) => i.severity === 'WARNING');

  return (
    <div className="cov-modal-overlay" onClick={onClose}>
      <div className="cov-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="cov-modal-head">
          <h3 style={{ margin: 0, fontSize: '1.125rem' }}>Проверка каталога и валидация</h3>
          <button className="cov-btn cov-btn-outline" onClick={onClose}>✕</button>
        </div>

        <div className="cov-modal-body">
          {issues.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem 1rem', color: '#10b981' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>✓</div>
              <h4 style={{ margin: '0 0 0.25rem 0', color: '#fff' }}>Каталог полностью валиден</h4>
              <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.875rem' }}>
                Ошибок и предупреждений не обнаружено. Каталог готов к публикации.
              </p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <div style={{ display: 'flex', gap: '1rem', fontSize: '0.8125rem' }}>
                <span style={{ color: '#ef4444', fontWeight: 600 }}>Блокирующих ошибок: {errors.length}</span>
                <span style={{ color: '#f59e0b', fontWeight: 600 }}>Предупреждений: {warnings.length}</span>
              </div>

              {issues.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    background: item.severity === 'ERROR' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(245, 158, 11, 0.1)',
                    border: `1px solid ${item.severity === 'ERROR' ? '#ef4444' : '#f59e0b'}`,
                    borderRadius: '8px',
                    padding: '0.75rem 1rem',
                    fontSize: '0.8125rem',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                    <span style={{ fontWeight: 700, color: item.severity === 'ERROR' ? '#f87171' : '#fbbf24' }}>
                      {item.severity} · {item.object_type}
                    </span>
                    <span style={{ color: '#94a3b8', fontSize: '0.75rem' }}>{item.object_id}</span>
                  </div>
                  <div style={{ color: '#e2e8f0' }}>{item.message}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="cov-modal-foot">
          <button className="cov-btn cov-btn-outline" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
};
